import { createContext, useContext } from 'react'

export const SurveyParamsContext = createContext({
  userId: null,
  sfdPId: null,
  sfdSamplerId: null,
})

export const useSurveyParams = () => useContext(SurveyParamsContext)
